function getConfig () {
  return {
    current: 'template-default',
    templates: {
      'template-default': {
        // 为了支持新的需求变更，想了想，更好的做法就是在此开辟一个data字段
        data: {
          // 还是不要在此做导航栏重命名，是否启用等需求了，纠结😖
          // navs: [
          //   { id: 1, name: 'PageHome', label: '首页', enabled: true },
          //   { id: 2, name: 'PageProducts', label: '产品与服务', enabled: true },
          //   { id: 3, name: 'PageProductDetail', label: '产品详情', enabled: true },
          //   { id: 4, name: 'PageArticles', label: '资讯动态', enabled: true },
          //   { id: 5, name: 'PageArticleDetail', label: '资讯详情', enabled: true },
          //   { id: 6, name: 'PageCases', label: '合作案例', enabled: true },
          //   { id: 7, name: 'PageAbout', label: '关于我们', enabled: true }
          // ]
        },
        components: {
          'app-header': {
            name: 'app-header',
            label: '页头组件',
            data: {
              logo: '',
              // activeNavs: [ 'PageHome', 'PageProducts', 'PageArticles', 'PageCases', 'PageAbout' ],
              systemNavs: [
                { name: 'PageHome', label: '首页', url: '', show: true },
                { name: 'PageProducts', label: '产品与服务', url: '', show: true },
                { name: 'PageArticles', label: '资讯动态', url: '', show: true },
                { name: 'PageCases', label: '合作案例', url: '', show: true },
                { name: 'PageAbout', label: '关于我们', url: '', show: true }
              ],
              customNavs: []
            },
            schema: {
              logo: {
                label: 'Logo',
                tip: '建议图片高度80px，格式为.png、.jpg以及.jpeg',
                type: 'image'
              },
              // activeNavs: {
              //   label: '导航栏',
              //   type: 'checkbox',
              //   options: [
              //     { label: '首页', value: 'PageHome', checked: true, disabled: true },
              //     { label: '产品与服务', value: 'PageProducts', checked: true, disabled: true },
              //     { label: '资讯动态', value: 'PageArticles', checked: true, disabled: true },
              //     { label: '合作案例', value: 'PageCases', checked: true, disabled: false },
              //     { label: '关于我们', value: 'PageAbout', checked: true, disabled: true }
              //   ]
              // },
              systemNavs: {
                type: 'list',
                label: '系统导航',
                canAddAndRemove: false,
                getEmptyItem: () => ({ name: '', label: '', url: '', show: true }),
                fields: {
                  show: {
                    label: '是否显示',
                    type: 'switch'
                  },
                  label: {
                    label: '名称',
                    type: 'input',
                    placeholder: '请输入名称',
                    rules: [
                      { required: true, message: '请输入名称', trigger: 'change' },
                      { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                    ]
                  },
                  name: {
                    label: '路由名',
                    tip: '由系统生成的路由名称，不可修改',
                    type: 'input',
                    placeholder: '请输入路由名',
                    disabled: true,
                    rules: [
                      { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                    ]
                  }
                }
              },
              customNavs: {
                type: 'list',
                label: '自定义导航',
                canAddAndRemove: true,
                getEmptyItem: () => ({ name: '', label: '', url: '', show: true }),
                fields: {
                  show: {
                    label: '是否显示',
                    type: 'switch'
                  },
                  label: {
                    label: '名称',
                    type: 'input',
                    placeholder: '请输入名称',
                    rules: [
                      { required: true, message: '请输入名称', trigger: 'change' },
                      { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                    ]
                  },
                  name: {
                    label: '路由名',
                    tip: '只能填写由系统生成的路由名称，否则无效',
                    type: 'input',
                    placeholder: '请输入路由名',
                    rules: [
                      { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                    ]
                  },
                  url: {
                    label: '链接',
                    tip: '自定义链接，可不输入路由名',
                    type: 'input',
                    placeholder: '请输入链接',
                    rules: [
                      { type: 'url', message: '请输入正确格式的链接', trigger: 'change' }
                    ]
                  }
                }
              }
            },
            rules: {
              logo: { required: true, message: '请上传云站点Logo', trigger: 'change' }
            }
          },
          'app-qq-contact': {
            name: 'app-qq-contact',
            label: 'QQ在线咨询组件',
            data: {
              items: [
                { qq: '', name: '', code: '' }
              ]
            },
            schema: {
              items: {
                type: 'list',
                label: 'QQ',
                canAddAndRemove: true,
                getEmptyItem: () => ({ qq: '', name: '', code: '' }),
                fields: {
                  qq: {
                    label: 'QQ号',
                    type: 'input',
                    placeholder: '请输入QQ号',
                    rules: [
                      { required: true, message: '请输入QQ号', trigger: 'change' },
                      { min: 4, max: 18, message: 'QQ号：4~18字', trigger: 'change' }
                    ]
                  },
                  name: {
                    label: '姓名',
                    type: 'input',
                    placeholder: '请输入姓名',
                    rules: [
                      { required: true, message: '请输入姓名', trigger: 'change' },
                      { min: 2, max: 10, message: '姓名：2~10字', trigger: 'change' }
                    ]
                  },
                  code: {
                    label: '代码',
                    tip: '如何获取代码？请前往：<a href="http://shang.qq.com/v3/widget.html" target="_blank" style="color:#2a85ff">http://shang.qq.com/v3/widget.html</a>',
                    type: 'textarea',
                    placeholder: '请输入代码',
                    rules: [
                      { required: true, message: '请输入代码', trigger: 'change' }
                    ]
                  }
                }
              }
            }
          },
          // 'app-footer': {
          //   name: 'app-footer',
          //   label: '页脚组件',
          //   data: {
          //     telephone: '0755-2673XXX',
          //     email: 'service@xxx.com',
          //     address: '广东省深圳市南山区大学城'
          //   },
          //   schema: {
          //     telephone: {
          //       label: '电话',
          //       type: 'input',
          //       placeholder: '请输入电话'
          //     },
          //     email: {
          //       label: '邮箱',
          //       type: 'input',
          //       placeholder: '请输入邮箱'
          //     },
          //     address: {
          //       label: '地址',
          //       type: 'input',
          //       placeholder: '请输入地址'
          //     }
          //   },
          //   rules: {
          //     telephone: [
          //       { required: true, message: '请输入电话', trigger: 'change' },
          //       { min: 7, max: 14, message: '电话：7~14字', trigger: 'change' }
          //     ],
          //     email: [
          //       { required: true, message: '请输入邮箱', trigger: 'change' },
          //       { type: 'email', message: '请输入正确格式的邮箱', trigger: 'change' }
          //     ],
          //     address: [
          //       { required: true, message: '请输入地址', trigger: 'change' }
          //     ]
          //   }
          // },
          'app-contact-data': {
            name: 'app-contact-data',
            label: '基础信息',
            data: {
              companyShortName: '',
              avatar: '',
              linkman: '',
              telephone: '',
              qq: '',
              wechat: '',
              wechatQRCode: '',
              email: '',
              address: ''
            },
            schema: {
              companyShortName: {
                label: '公司简称',
                type: 'input',
                placeholder: '请输入公司简称'
              },
              avatar: {
                label: '头像',
                tip: '建议图片尺寸220px * 220px，格式为.png、.jpg以及.jpeg',
                type: 'image'
              },
              linkman: {
                label: '联系人',
                type: 'input',
                placeholder: '请输入联系人'
              },
              telephone: {
                label: '电话',
                type: 'input',
                placeholder: '请输入电话'
              },
              qq: {
                label: 'QQ号',
                type: 'input',
                placeholder: '请输入QQ号'
              },
              wechat: {
                label: '微信号',
                type: 'input',
                placeholder: '请输入微信号'
              },
              wechatQRCode: {
                label: '微信二维码',
                tip: '建议图片尺寸220px * 220px，格式为.png、.jpg以及.jpeg',
                type: 'image'
              },
              email: {
                label: '邮箱',
                type: 'input',
                placeholder: '请输入邮箱'
              },
              address: {
                label: '地址',
                type: 'input',
                placeholder: '请输入地址'
              }
            },
            rules: {
              companyShortName: [
                { max: 18, message: '公司简称：最多18字', trigger: 'change' }
              ],
              linkman: [
                { required: true, message: '请输入联系人', trigger: 'change' },
                { min: 2, max: 10, message: '电话：2~10字', trigger: 'change' }
              ],
              avatar: [
                { required: true, message: '请上传头像', trigger: 'change' }
              ],
              telephone: [
                { required: true, message: '请输入电话', trigger: 'change' },
                { min: 7, max: 14, message: '电话：7~14字', trigger: 'change' }
              ],
              qq: [
                { required: true, message: '请输入QQ号', trigger: 'change' },
                { min: 4, max: 18, message: 'QQ号：4~18字', trigger: 'change' }
              ],
              wechat: [
                { required: true, message: '请输入微信号', trigger: 'change' },
                { min: 4, max: 30, message: '微信号：4~30字', trigger: 'change' }
              ],
              wechatQRCode: [
                { required: true, message: '请上传微信二维码', trigger: 'change' }
              ],
              email: [
                { required: true, message: '请输入邮箱', trigger: 'change' },
                { type: 'email', message: '请输入正确格式的邮箱', trigger: 'change' }
              ],
              address: [
                { required: true, message: '请输入地址', trigger: 'change' },
                { min: 2, max: 50, message: '电话：2~50字', trigger: 'change' }
              ]
            }
          }
        },
        pages: {
          'index': {
            name: 'index',
            label: '首页',
            components: {
              'app-carousel': {
                name: 'app-carousel',
                label: '轮播图组件',
                data: {
                  show: true,
                  items: [
                    { image: '', url: '' }
                  ]
                },
                schema: {
                  show: {
                    label: '是否显示',
                    type: 'switch'
                  },
                  items: {
                    type: 'list',
                    label: '轮播图',
                    canAddAndRemove: true,
                    getEmptyItem: () => ({ title: '', url: '' }),
                    fields: {
                      image: {
                        label: '轮播图图片',
                        tip: '建议图片尺寸1920px * 540px，格式为.png、.jpg以及.jpeg',
                        type: 'image',
                        rules: { required: true, message: '请上传轮播图图片', trigger: 'input' }
                      },
                      url: {
                        label: '轮播图链接',
                        type: 'input',
                        placeholder: '请输入轮播图链接',
                        rules: [
                          { required: true, message: '请输入轮播图链接', trigger: 'change' },
                          { type: 'url', message: '请输入正确格式的链接', trigger: 'change' }
                        ]
                      }
                    }
                  }
                },
                rules: {}
              }, // app-carousel
              'app-home-products': {
                name: 'app-home-products',
                label: '热门产品组件',
                data: {
                  show: true,
                  title: '热门产品',
                  summary: ''
                },
                schema: {
                  show: {
                    label: '是否显示',
                    type: 'switch'
                  },
                  title: {
                    label: '标题',
                    type: 'input',
                    placeholder: '请输入标题'
                  },
                  summary: {
                    label: '简介',
                    type: 'textarea',
                    placeholder: '请输入简介'
                  }
                },
                rules: {
                  title: [
                    { required: true, message: '请输入标题', trigger: 'change' },
                    { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                  ],
                  summary: [
                    { min: 10, max: 50, message: '标题：10~50字', trigger: 'change' }
                  ]
                }
              }, // app-home-products
              'app-home-cases': {
                name: 'app-home-cases',
                label: '合作案例组件',
                data: {
                  show: true,
                  title: '合作案例',
                  summary: ''
                },
                schema: {
                  show: {
                    label: '是否显示',
                    type: 'switch'
                  },
                  title: {
                    label: '标题',
                    type: 'input',
                    placeholder: '请输入标题'
                  },
                  summary: {
                    label: '简介',
                    type: 'textarea',
                    placeholder: '请输入简介'
                  }
                },
                rules: {
                  title: [
                    { required: true, message: '请输入标题', trigger: 'change' },
                    { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                  ],
                  summary: [
                    { min: 10, max: 50, message: '标题：10~50字', trigger: 'change' }
                  ]
                }
              }, // app-home-cases
              'app-home-source': {
                name: 'app-home-source',
                label: '图文组件(无链接)',
                data: {
                  show: true,
                  title: '图文标题',
                  summary: '',
                  items: [ { title: '', summary: '', image: '' } ]
                },
                schema: {
                  show: {
                    label: '是否显示',
                    type: 'switch'
                  },
                  title: {
                    label: '标题',
                    type: 'input',
                    placeholder: '请输入标题'
                  },
                  summary: {
                    label: '简介',
                    type: 'textarea',
                    placeholder: '请输入简介'
                  },
                  items: {
                    type: 'list',
                    label: '图文',
                    canAddAndRemove: true,
                    getEmptyItem: () => ({ title: '', summary: '', image: '' }),
                    fields: {
                      image: {
                        label: '图片',
                        tip: '建议图片尺寸200px * 200px，格式为.png、.jpg以及.jpeg',
                        type: 'image',
                        rules: { required: true, message: '请上传图片', trigger: 'input' }
                      },
                      title: {
                        label: '标题',
                        type: 'input',
                        placeholder: '请输入标题',
                        rules: [
                          { required: true, message: '请输入标题', trigger: 'change' },
                          { min: 2, max: 10, message: '标题：2~10字', trigger: 'change' }
                        ]
                      },
                      summary: {
                        label: '简介',
                        type: 'textarea',
                        placeholder: '请输简介',
                        rules: [
                          { required: true, message: '请输入简介', trigger: 'change' },
                          { min: 10, max: 50, message: '标题：10~50字', trigger: 'change' }
                        ]
                      }
                    }
                  }
                },
                rules: {
                  title: [
                    { required: true, message: '请输入标题', trigger: 'change' },
                    { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                  ],
                  summary: [
                    { min: 10, max: 50, message: '标题：10~50字', trigger: 'change' }
                  ]
                }
              }, // app-home-source
              'app-home-news': {
                name: 'app-home-news',
                label: '热门资讯组件',
                data: {
                  show: true,
                  title: '热门资讯',
                  summary: ''
                },
                schema: {
                  show: {
                    label: '是否显示',
                    type: 'switch'
                  },
                  title: {
                    label: '标题',
                    type: 'input',
                    placeholder: '请输入标题'
                  },
                  summary: {
                    label: '简介',
                    type: 'textarea',
                    placeholder: '请输入简介'
                  }
                },
                rules: {
                  title: [
                    { required: true, message: '请输入标题', trigger: 'change' },
                    { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                  ],
                  summary: [
                    { min: 10, max: 50, message: '标题：10~50字', trigger: 'change' }
                  ]
                }
              } // app-home-news
            }
          }, // index
          'products': {
            name: 'products',
            label: '产品与服务',
            components: {
              'app-pagination': {
                name: 'app-pagination',
                label: '分页组件',
                data: {
                  pageSize: 16
                },
                schema: {
                  pageSize: {
                    label: '分页大小',
                    type: 'number',
                    min: 4,
                    max: 20,
                    step: 4
                  }
                },
                rules: {}
              }
            }
          }, // products
          'news': {
            name: 'news',
            label: '资讯动态',
            components: {
              'app-pagination': {
                name: 'app-pagination',
                label: '分页组件',
                data: {
                  pageSize: 10
                },
                schema: {
                  pageSize: {
                    label: '分页大小',
                    type: 'number',
                    min: 5,
                    max: 20,
                    step: 5
                  }
                },
                rules: {}
              }
            }
          }, // news
          'articleDetail': {
            name: 'articleDetail',
            label: '资讯详情',
            components: {
              'app-image-ad': {
                name: 'app-image-ad',
                label: '图片广告组件',
                data: {
                  image: '',
                  url: ''
                },
                schema: {
                  image: {
                    label: '广告图片',
                    tip: '建议图片尺寸768px * 264px，格式为.png、.jpg以及.jpeg',
                    type: 'image',
                    rules: { required: true, message: '请上传广告图片', trigger: 'input' }
                  },
                  url: {
                    label: '广告链接',
                    type: 'input',
                    placeholder: '请输入广告链接',
                    rules: [
                      { required: true, message: '请输入广告链接', trigger: 'change' },
                      { type: 'url', message: '请输入正确格式的链接', trigger: 'change' }
                    ]
                  }
                },
                rules: {}
              },
              'app-text-ad': {
                name: 'app-text-ad',
                label: '文本广告组件',
                data: {
                  title: '',
                  items: [
                    { text: '', url: '' }
                  ]
                },
                schema: {
                  title: {
                    label: '栏目标题',
                    type: 'input',
                    placeholder: '请输入栏目标题'
                  },
                  items: {
                    type: 'list',
                    label: '广告链接',
                    canAddAndRemove: true,
                    getEmptyItem: () => ({ text: '', url: '' }),
                    fields: {
                      text: {
                        label: '标题',
                        type: 'input',
                        placeholder: '请输入标题',
                        rules: [
                          { required: true, message: '请输入标题', trigger: 'change' },
                          { min: 2, max: 50, message: '标题：2~50字', trigger: 'change' }
                        ]
                      },
                      url: {
                        label: '链接',
                        type: 'input',
                        placeholder: '请输入链接',
                        rules: [
                          { required: true, message: '请输入链接', trigger: 'change' },
                          { type: 'url', message: '请输入正确格式的链接', trigger: 'change' }
                        ]
                      }
                    }
                  }
                },
                rules: {
                  title: [
                    { required: true, message: '请输入标题', trigger: 'change' },
                    { min: 2, max: 20, message: '标题：2~20字', trigger: 'change' }
                  ]
                }
              }
            }
          }, // news
          'cases': {
            name: 'cases',
            label: '资讯动态',
            components: {
              'app-pagination': {
                name: 'app-pagination',
                label: '分页组件',
                data: {
                  pageSize: 9
                },
                schema: {
                  pageSize: {
                    label: '分页大小',
                    type: 'number',
                    min: 3,
                    max: 18,
                    step: 3
                  }
                },
                rules: {}
              }
            }
          }, // cases
          'about': {
            name: 'about',
            label: '关于我们',
            components: {
              'app-about-us': {
                name: 'app-about-us',
                label: '关于我们组件',
                data: {
                  image: '',
                  title: '关于我们',
                  description: ''
                },
                schema: {
                  image: {
                    label: '图片',
                    tip: '建议图片尺寸550px * 330px，格式为.png、.jpg以及.jpeg',
                    type: 'image'
                  },
                  title: {
                    label: '标题',
                    type: 'input',
                    placeholder: '请输入标题'
                  },
                  description: {
                    label: '简介',
                    type: 'editor',
                    placeholder: '请输简介'
                  }
                },
                rules: {
                  image: { required: true, message: '请上关于我们的图片', trigger: 'input' },
                  title: [
                    { required: true, message: '请输入标题', trigger: 'change' },
                    { min: 2, max: 10, message: '标题：2~10字', trigger: 'change' }
                  ],
                  description: [
                    { required: true, message: '请输入简介', trigger: 'change' },
                    { min: 100, max: 2000, message: '标题：100~2000字', trigger: 'change' }
                  ]
                }
              },
              'app-baidu-map': {
                name: 'app-baidu-map',
                label: '地图位置组件',
                data: {
                  point: null
                },
                schema: {
                  point: {
                    label: '公司位置',
                    tip: '请在地图上选择公司地址',
                    type: 'map'
                  }
                },
                rules: {}
              }
            }
          } // about
        } // pages
      }
    }
  }
}

/**
 * 提交数据时，提取配置数据，剥离不必要的数据
 * Note: 暂时写成这么丑陋
 * @param {Object} configs 配置
 */
function getData (configs) {
  const obj = {}

  for (const configName in configs) {
    if (configName === 'templates') {
      obj[configName] = {}

      // 模板
      const templates = configs[configName]
      for (const templateName in templates) {
        obj[configName][templateName] = { data: {}, components: {}, pages: {} }

        // 公共数据
        const data = templates[templateName]['data']
        if (data) {
          obj[configName][templateName].data = data
        }

        // 公共组件
        const components = templates[templateName]['components']
        for (const componentName in components) {
          obj[configName][templateName]['components'][componentName] = {
            data: components[componentName].data
          }
        }

        // 页面
        const pages = templates[templateName]['pages']
        for (const pageName in pages) {
          obj[configName][templateName]['pages'][pageName] = { components: {} }

          // 页面下的组件
          const components = pages[pageName]['components']
          for (const componentName in components) {
            obj[configName][templateName]['pages'][pageName]['components'][componentName] = {
              data: components[componentName].data
            }
          }
        }
      }
    } else {
      obj[configName] = configs[configName]
    }
  }

  return obj
}

/**
 * 拉取用户配置数据，与本地配置数据合并
 * Note: 暂时写成这么丑陋，没有做深拷贝
 * @param {Object} localConfigs 本地配置
 * @param {Object} remoteConfigs 远程配置
 * @return {Object} 合并后的本地配置
 */
function mergeConfig (localConfigs, remoteConfigs) {
  if (isEmpty(remoteConfigs)) return localConfigs

  for (const configName in localConfigs) {
    if (configName === 'templates') {
      // 模板
      const localTemplates = localConfigs[configName]
      const remoteTemplates = remoteConfigs[configName]

      if (isEmpty(remoteTemplates)) continue

      for (const templateName in localTemplates) {
        const localTemplate = localTemplates[templateName]
        const remoteTemplate = remoteTemplates[templateName]

        if (isEmpty(remoteTemplate)) continue

        // 公共数据
        const localData = localTemplate.data
        const remoteData = remoteTemplate.data
        if (!isEmpty(remoteData)) {
          for (const dataField in localData) {
            // 数据字段
            const localDataField = localData[dataField]
            const remoteDataField = remoteData[dataField]

            if (isEmpty(remoteDataField)) continue
            Object.assign(localDataField, remoteDataField)
          }
        }

        // 公共组件
        const localComponents = localTemplate.components
        const remoteComponents = remoteTemplate.components

        if (!isEmpty(remoteComponents)) {
          for (const componentName in localComponents) {
            // 组件数据
            const localComponent = localComponents[componentName]
            const remoteComponent = remoteComponents[componentName]

            if (isEmpty(remoteComponent)) continue
            for (const field in localComponent.data) {
              localComponent.data[field] = getProperty(field, localComponent.data, remoteComponent.data)
            }
          }
        }

        // 页面
        const localPages = localTemplate.pages
        const remotePages = remoteTemplate.pages

        if (!isEmpty(remotePages)) {
          for (const pageName in localPages) {
            // 页面组件
            const localPage = localPages[pageName]
            const remotePage = remotePages[pageName]

            if (isEmpty(remotePage) || isEmpty(remotePage.components)) continue
            for (const componentName in localPage.components) {
              // 组件数据
              const localComponent = localPage.components[componentName]
              const remoteComponent = remotePage.components[componentName]

              if (isEmpty(remoteComponent)) continue
              for (const field in localComponent.data) {
                localComponent.data[field] = getProperty(field, localComponent.data, remoteComponent.data)
              }
            }
          }
        }
      }
    } else {
      localConfigs[configName] = getProperty(configName, localConfigs, remoteConfigs)
    }
  }
  console.log('localConfigs:', localConfigs)
  return localConfigs
}

function isEmpty (obj) {
  return !obj || !Object.keys(obj).length
}

function getProperty (field, localConfigs, remoteConfig = {}) {
  return remoteConfig.hasOwnProperty(field) ? remoteConfig[field] : localConfigs[field]
}

export default {
  getConfig,
  mergeConfig,
  getData
}
